import React, { useState } from "react";
import "./AdminLogin.css"; // das Styling

const AdminLogin = ({ onSuccess }) => {
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (user === "adminreebaq" && pass === "reebaq-admin-2025-x-3") {
      onSuccess();
    } else {
      setError("Ungültige Zugangsdaten");
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2 className="login-title">Admin Login</h2>

        <p className="info-text">
          Reebaq befindet sich gerade in der Testphase. Wir sind bald live!
        </p>

        {error && <p className="error-text">{error}</p>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Benutzername</label>
            <input
              type="text"
              value={user}
              onChange={(e) => setUser(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Passwort</label>
            <input
              type="password"
              value={pass}
              onChange={(e) => setPass(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="login-button">
            Einloggen
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
